<template>
  <basic-portlet :title="`(BETA) Edit Live Feed : ${premium.name}`">
    <div class="row">
      <div class="col-8">
        <div class="alert alert-outline-info fade show" role="alert">
          <div class="alert-icon">
            <i class="flaticon-questions-circular-button" />
          </div>
          <div class="alert-text">
            Editing of Live Feeds is currently in Beta stages of development and therefore has limited features.
          </div>
        </div>

        <div class="form-group mt-4">
          <FormulateForm
            @submit="submit">
            <FormulateInput
              v-model="premium.name"
              input-class="form-control"
              name="name"
              label="Live Feed name"
              validation="required|max:191" />
            <div class="w-25 mt-4">
              <display-with-selection-modal :preselected-artwork="selected_artwork" @selected="(ev) => (selected_artwork = ev.selected_artwork)" />
            </div>
            <FormulateInput
              type="submit"
              :title="`${can_update ? 'Update Live Feed' : 'You do not have permissions to update Live Feeds'}`"
              :input-class="`btn btn-ss-standout mt-2 ${!can_update ? 'cursor-not-allowed': ''}`"
              :disabled="!can_update"
              label="Update" />
          </FormulateForm>
        </div>
      </div>
    </div>
    <quick-alert-modal v-bind="quick_alert" />
  </basic-portlet>
</template>

<script>

import VueFormulate from '@braid/vue-formulate';
import BasicPortlet from "VueComponents/BasicPortlet";
import DisplayWithSelectionModal from 'VuePartials/Artwork/DisplayWithSelectionModal.vue';
window.Vue.use(VueFormulate);

export default {
  components: { BasicPortlet, DisplayWithSelectionModal },
  data: () => ({
    premium: null,
    extra: null,
    can_update: true,
    selected_artwork: null,
  }),

  beforeMount() {
    this.premium = window.premium;
    this.selected_artwork = this.premium.artwork;
    this.can_update = this.permissionsCanDoAction('api.live-feeds.update');
  },

  mounted() {
    EventBus.$on('new_artwork_selected', (payload) => {
      toastr.success("New Artwork Selected.");
      this.selected_artwork = payload;
    });
  },

  methods: {

    async submit() {
      if (!this.can_update) {
        this.quickAlert({
          title: `Failed!`,
          message: `You do not have permission to update Live Feeds. Please contact your account admin.`,
          variant: `error`,
        });
      }

      const payload = { name: this.premium.name };

      if (this.selected_artwork) {
        payload.artwork_uuid = this.selected_artwork.uuid;
      }

      try {
        const response = await axios.patch(`/api/v1/live-feeds/${this.premium.uuid}`, payload);

        if (response.data.success) {
          await this.quickAlert({
            title: `Updated!`,
            message: `Live Feed updated successfully!`,
            variant: `success`,
          });

          window.location.href = '/live-feeds';
        } else {
          this.quickAlert({
            title: `Failed!`,
            message: _.capitalize(response.data.error.message),
            variant: `error`,
          });
        }
      } catch (e) {
        this.quickAlert({
          title: `Oops!`,
          message: `Exception has occurred. Please check your input is valid!`,
          variant: `error`,
        });
      }
    },

  },

};
</script>
